<div
  class="mobile-sheet"
  [@slideUpDown]="animationState"
  (@slideUpDown.done)="onAnimationDone($event)"
  (@slideUpDown.start)="onAnimationStart($event)"
>
  <div class="sheet-header"></div>
  <div class="sheet-content">
    @if (data?.type === 'add') {
      <!-- <ddc-add-mobile-sheet></ddc-add-mobile-sheet> -->
      <ddc-add-dialog [isMobileSheet]="true" (closeSheet)="close()"></ddc-add-dialog>
    } @else if (data?.type === 'add-to-dic') {
      <ddc-add-mobile-sheet [target_dic]="data.element"></ddc-add-mobile-sheet>
    } @else if (data?.type === 'read-word') {
      <ddc-read-word-mobile-sheet [word]="data.element"></ddc-read-word-mobile-sheet>
    } @else if (data?.type === 'read-pair') {
      <ddc-read-pair-mobile-sheet [pair]="data.element"></ddc-read-pair-mobile-sheet>
    } @else if (data?.type === 'read-dic') {
      <ddc-read-word-mobile-sheet [word]="data.element"></ddc-read-word-mobile-sheet>
    } @else if (data?.type === 'read-note') {
      <ddc-read-note-mobile-sheet [note]="data.element"></ddc-read-note-mobile-sheet>
    } @else if (data?.type === 'read-quiz') {
      <ddc-read-quiz-mobile-sheet [quiz]="data.element"></ddc-read-quiz-mobile-sheet>
    } @else if (data?.type === 'read-figure') {
      <ddc-read-figure-mobile-sheet [figure]="data.element"></ddc-read-figure-mobile-sheet>
    } @else if (data?.type === 'edit-word') {
      <ddc-edit-mobile-sheet [word]="data.element"></ddc-edit-mobile-sheet>
    } @else if (data?.type === 'edit-pair') {
      <ddc-edit-mobile-sheet [pair]="data.element"></ddc-edit-mobile-sheet>
    } @else if (data?.type === 'edit-dic') {
      <ddc-edit-mobile-sheet [dictionary]="data.element"></ddc-edit-mobile-sheet>
    } @else if (data?.type === 'edit-collection') {
      <ddc-edit-mobile-sheet [collection]="data.element"></ddc-edit-mobile-sheet>
    } @else if (data?.type === 'upgrade') {
      <ddc-upgrade-mobile-sheet></ddc-upgrade-mobile-sheet>
    } @else if (data?.type === 'generate_pdf') {
      <ddc-generate-pdf-mobile-sheet></ddc-generate-pdf-mobile-sheet>
    } @else if (data?.type === 'filter') {
      <ddc-filter-mobile-sheet [type]="data.element"></ddc-filter-mobile-sheet>
    } @else if (data?.type === 'configure') {
      <node-config-dialog
        [data]="data.element"
        (cancelled)="onCancelled()"
        (configured)="onConfigured($event)"
      ></node-config-dialog>
    } @else if (data?.type === 'loading') {
      <!-- Loading content for mobile -->
      <div class="loading-dialog-content mobile-loading">
        <mat-spinner class="loading-spinner" [diameter]="40"></mat-spinner>
        <p class="loading-message">{{ data.message || 'Loading...' }}</p>
        <p class="loading-submessage" *ngIf="data.submessage">{{ data.submessage }}</p>
      </div>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>
